import React from "react";
import { Link, useLocation } from "react-router-dom";
import logoHetki from "../assets/logos/Hetki-Company-logo_black.png";
import logoFilm from "../assets/logos/Hetki-Company-Film-logo_black.png";
import { site } from "../data/site";
import { useLang, pick } from "../i18n/LanguageContext";
import { t } from "../i18n/translations";

const Footer = () => {
  const { lang } = useLang();
  const tr = pick(lang);
  // Puolet pidetään erillään: /film-sivulla footerissa Film-logo, joka vie
  // /film-sivulle, eikä linkkejä Hetki-puolen sivuille. Muualla logo
  // vie /hetki-sivulle ja sivulinkit toistavat yläreunan navigaation.
  // Copyright ja yhteystiedot ovat yhteiset (yrityksen juridinen tunniste).
  const isFilm = useLocation().pathname === "/film";
  const pages = [
    { to: "/tyot", label: t.nav.work },
    { to: "/palvelut", label: t.nav.services },
    { to: "/yhteys", label: t.nav.contact },
  ];

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <Link
            to={isFilm ? "/film" : "/hetki"}
            aria-label={tr(isFilm ? t.nav.homeFilm : t.nav.home)}
          >
            {isFilm ? (
              <img src={logoFilm} alt="Hetki Film Company" />
            ) : (
              <img src={logoHetki} alt="Hetki" />
            )}
          </Link>
        </div>

        {!isFilm && (
          <nav className="footer__nav" aria-label={tr(t.footer.nav)}>
            {pages.map((p) => (
              <Link key={p.to} to={p.to} className="footer__nav-link">
                {tr(p.label)}
              </Link>
            ))}
          </nav>
        )}

        <div className="footer__col">
          <h3 className="footer__heading">{tr(t.footer.contact)}</h3>
          <a href={`mailto:${site.contact.email}`} className="footer__link">
            {site.contact.email}
          </a>
          <a
            href={`tel:${site.contact.phone.replace(/\s+/g, "")}`}
            className="footer__link"
          >
            {site.contact.phone}
          </a>
          <a
            href={`https://wa.me/${site.contact.whatsapp.replace(/\D/g, "")}`}
            className="footer__link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {tr(t.yhteys.whatsapp)}
          </a>
          <span className="footer__text">
            {Array.isArray(site.contact.address)
              ? site.contact.address.join(", ")
              : site.contact.address}
          </span>
        </div>

        <div className="footer__copyright">{site.copyright}</div>
      </div>
    </footer>
  );
};

export default Footer;
